import { render, staticRenderFns } from "./ActiveCashCollectionsByDateReport.vue?vue&type=template&id=0c478e0a&"
import script from "./ActiveCashCollectionsByDateReport.vue?vue&type=script&lang=js&"
export * from "./ActiveCashCollectionsByDateReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports